import React from "react";
import { Crown } from "lucide-react";

// The one "Upgrade" button look used across the app (2026-09-29: "modernize
// ... upgrade buttons everywhere"). Bronze gradient pill with a soft glow;
// `variant="outline"` for secondary placements, `size="sm"` for inline ones.
// Pass onClick (usually openUpgrade(reason) from lib/plans, or a page's own
// paywall setter).
export function UpgradeButton({ children = "Upgrade", onClick, size = "md", variant = "solid", full = false, icon: Icon = Crown, className = "", ...rest }) {
  const sizing = size === "sm" ? "px-3.5 py-1.5 text-[11px]" : "px-5 py-2.5 text-xs";
  const look = variant === "outline"
    ? "border border-[#A67C52]/60 text-[#C9A27A] hover:border-[#A67C52] hover:bg-[#A67C52]/10"
    : "bg-gradient-to-r from-[#A67C52] via-[#C9A27A] to-[#A67C52] bg-[length:200%_100%] bg-left hover:bg-right text-white shadow-lg shadow-[#A67C52]/25 ring-1 ring-inset ring-white/20 hover:shadow-[#A67C52]/40";
  return (
    <button
      type="button"
      onClick={onClick}
      className={`group inline-flex items-center justify-center gap-1.5 rounded-full font-bold tracking-wide transition-all duration-300 hover:-translate-y-0.5 active:translate-y-0 disabled:opacity-60 disabled:hover:translate-y-0 ${sizing} ${look} ${full ? "w-full" : ""} ${className}`}
      {...rest}
    >
      {Icon && <Icon className={`${size === "sm" ? "size-3" : "size-3.5"} transition-transform group-hover:rotate-[-8deg] group-hover:scale-110`} />}
      {children}
    </button>
  );
}
